[
  {
    "code": "NZ-CAN-063",
    "name": "Ashburton District"
  },
  {
    "code": "NZ-AUK-007",
    "name": "Auckland City"
  },
  {
    "code": "NZ-WTC-055",
    "name": "Buller District"
  },
  {
    "code": "NZ-WGN-049",
    "name": "Carterton District"
  },
  {
    "code": "NZ-HKB-032",
    "name": "Central Hawke's Bay District"
  },
  {
    "code": "NZ-OTA-069",
    "name": "Central Otago District"
  },
  {
    "code": "NZ-CAN-060",
    "name": "Christchurch City"
  },
  {
    "code": "NZ-OTA-072",
    "name": "Clutha District"
  },
  {
    "code": "NZ-OTA-071",
    "name": "Dunedin City"
  },
  {
    "code": "NZ-NTL-001",
    "name": "Far North District"
  },
  {
    "code": "NZ-AUK-010",
    "name": "Franklin District"
  },
  {
    "code": "NZ-WKO-010",
    "name": "Franklin District"
  },
  {
    "code": "NZ-GIS-028",
    "name": "Gisborne District"
  },
  {
    "code": "NZ-STL-074",
    "name": "Gore District"
  },
  {
    "code": "NZ-WTC-056",
    "name": "Grey District"
  },
  {
    "code": "NZ-WKO-016",
    "name": "Hamilton City"
  },
  {
    "code": "NZ-HKB-030",
    "name": "Hastings District"
  },
  {
    "code": "NZ-WKO-012",
    "name": "Hauraki District"
  },
  {
    "code": "NZ-MWT-042",
    "name": "Horowhenua District"
  },
  {
    "code": "NZ-CAN-058",
    "name": "Hurunui District"
  },
  {
    "code": "NZ-STL-075",
    "name": "Invercargill City"
  },
  {
    "code": "NZ-CAN-054",
    "name": "Kaikoura District"
  },
  {
    "code": "NZ-NTL-003",
    "name": "Kaipara District"
  },
  {
    "code": "NZ-WGN-043",
    "name": "Kapiti Coast District"
  },
  {
    "code": "NZ-BOP-026",
    "name": "Kawerau District"
  },
  {
    "code": "NZ-WGN-046",
    "name": "Lower Hutt City"
  },
  {
    "code": "NZ-CAN-065",
    "name": "Mackenzie District"
  },
  {
    "code": "NZ-MWT-039",
    "name": "Manawatu District"
  },
  {
    "code": "NZ-AUK-008",
    "name": "Manukau City"
  },
  {
    "code": "NZ-MBH-053",
    "name": "Marlborough District"
  },
  {
    "code": "NZ-WGN-048",
    "name": "Masterton District"
  },
  {
    "code": "NZ-WKO-015",
    "name": "Matamata-Piako District"
  },
  {
    "code": "NZ-HKB-031",
    "name": "Napier City"
  },
  {
    "code": "NZ-NSN-052",
    "name": "Nelson City"
  },
  {
    "code": "NZ-TKI-033",
    "name": "New Plymouth District"
  },
  {
    "code": "NZ-AUK-005",
    "name": "North Shore City"
  },
  {
    "code": "NZ-BOP-027",
    "name": "Opotiki District"
  },
  {
    "code": "NZ-WKO-018",
    "name": "Otorohanga District"
  },
  {
    "code": "NZ-MWT-040",
    "name": "Palmerston North City"
  },
  {
    "code": "NZ-AUK-009",
    "name": "Papakura District"
  },
  {
    "code": "NZ-WGN-044",
    "name": "Porirua City"
  },
  {
    "code": "NZ-OTA-070",
    "name": "Queenstown-Lakes District"
  },
  {
    "code": "NZ-HKB-038",
    "name": "Rangitikei District"
  },
  {
    "code": "NZ-MWT-038",
    "name": "Rangitikei District"
  },
  {
    "code": "NZ-AUK-004",
    "name": "Rodney District"
  },
  {
    "code": "NZ-WKO-024",
    "name": "Rotorua District"
  },
  {
    "code": "NZ-BOP-024",
    "name": "Rotorua District"
  },
  {
    "code": "NZ-MWT-036",
    "name": "Ruapehu District"
  },
  {
    "code": "NZ-CAN-062",
    "name": "Selwyn District"
  },
  {
    "code": "NZ-TKI-035",
    "name": "South Taranaki District"
  },
  {
    "code": "NZ-WKO-019",
    "name": "South Waikato District"
  },
  {
    "code": "NZ-WGN-050",
    "name": "South Wairarapa District"
  },
  {
    "code": "NZ-STL-073",
    "name": "Southland District"
  },
  {
    "code": "NZ-MWT-034",
    "name": "Stratford District"
  },
  {
    "code": "NZ-TKI-034",
    "name": "Stratford District"
  },
  {
    "code": "NZ-WGN-041",
    "name": "Tararua District"
  },
  {
    "code": "NZ-MWT-041",
    "name": "Tararua District"
  },
  {
    "code": "NZ-TAS-051",
    "name": "Tasman District"
  },
  {
    "code": "NZ-WKO-021",
    "name": "Taupo District"
  },
  {
    "code": "NZ-HKB-021",
    "name": "Taupo District"
  },
  {
    "code": "NZ-MWT-021",
    "name": "Taupo District"
  },
  {
    "code": "NZ-BOP-021",
    "name": "Taupo District"
  },
  {
    "code": "NZ-BOP-023",
    "name": "Tauranga City"
  },
  {
    "code": "NZ-WKO-011",
    "name": "Thames-Coromandel District"
  },
  {
    "code": "NZ-CAN-064",
    "name": "Timaru District"
  },
  {
    "code": "NZ-WGN-045",
    "name": "Upper Hutt City"
  },
  {
    "code": "NZ-WKO-013",
    "name": "Waikato District"
  },
  {
    "code": "NZ-CAN-059",
    "name": "Waimakariri District"
  },
  {
    "code": "NZ-CAN-066",
    "name": "Waimate District"
  },
  {
    "code": "NZ-WKO-017",
    "name": "Waipa District"
  },
  {
    "code": "NZ-HKB-029",
    "name": "Wairoa District"
  },
  {
    "code": "NZ-AUK-006",
    "name": "Waitakere City"
  },
  {
    "code": "NZ-OTA-068",
    "name": "Waitaki District"
  },
  {
    "code": "NZ-CAN-068",
    "name": "Waitaki District"
  },
  {
    "code": "NZ-WKO-020",
    "name": "Waitomo District"
  },
  {
    "code": "NZ-MWT-020",
    "name": "Waitomo District"
  },
  {
    "code": "NZ-MWT-037",
    "name": "Wanganui District"
  },
  {
    "code": "NZ-WGN-047",
    "name": "Wellington City"
  },
  {
    "code": "NZ-BOP-022",
    "name": "Western Bay of Plenty District"
  },
  {
    "code": "NZ-WTC-057",
    "name": "Westland District"
  },
  {
    "code": "NZ-BOP-025",
    "name": "Whakatane District"
  },
  {
    "code": "NZ-NTL-002",
    "name": "Whangarei District"
  }
]